<template>
    <div class="order-list-page">
        <div class="pageCenter">
            <div class="pageTitle pageContent">
                <span class="text1">生产商</span> 
                <i class="el-icon-arrow-right arrow-right"></i>
                <span class="text1">订单管理</span> 
                <i class="el-icon-arrow-right arrow-right"></i>
                <span class="text2">我的订单</span>
            </div>
            <div class="searchWrap">
                <el-select v-model="search_type" placeholder="订单类型" @change="curRoutePush" size="small">
                    <el-option v-for="item in order_type_word" :key="item.value" :label="item.text"  :value="item.value"> </el-option>
                </el-select>
                <el-select v-model="search_status" placeholder="订单状态" @change="curRoutePush" size="small">
                    <el-option v-for="item in order_status_word" :key="item.value" :label="item.text"  :value="item.value"> </el-option>
                </el-select>
                <el-select v-model="search_sort" placeholder="订单排序" @change="curRoutePush" size="small">
                    <el-option v-for="item in order_sort_word" :key="item.value" :label="item.text"  :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="tableWrap">
                <el-table :data="tableData" style="width: 100%" v-loading="isLoading">
                    <el-table-column prop="order_name" label="订单信息" width="320">
                        <template slot-scope="scope">
                            <div class="orderImgTd">
                                <div class="avatarBox">
                                    <img :src="IMG_PREV+scope.row.image_file" alt="" class="listAvatar"
                                        @click="handleImgPreview(IMG_PREV+scope.row.image_file)"
                                    >
                                </div>
                                <div class="rightBox">
                                    <div class="nameLine" :title="scope.row.order_name">
                                        {{scope.row.order_name}}
                                    </div>
                                    <div class="timeLine">
                                        预计交货数量 {{scope.row.order_quantity}}件
                                    </div>
                                    <div class="timeLine">
                                        预计交货日期 {{scope.row.order_delivery_time}}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="order_unit_price" label="单价" width="110">
                        <template slot-scope="scope">
                            <span class="priceText"> ¥{{scope.row.order_unit_price}}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="order_type" label="订单类型" width="120">
                        <template slot-scope="scope">
                            <span :class="{yellowTag:scope.row.order_type=='cmt',blueTag:scope.row.order_type=='oem'}">
                                {{scope.row.order_type|turnValToText("order_type")}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="order_number" label="订单号"  width="160">
                    </el-table-column>
                  <!--  <el-table-column prop="order_type" label="ces">
                        <template slot-scope="scope">
                            <span>
                                {{scope.row.ces}}
                            </span>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="company_name" label="发单方" width="120">
                        <template slot-scope="scope">
                            <span>
                                {{scope.row.company_name}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="order_status" label="订单状态">
                        <template slot-scope="scope">
                            <span  :class="{red:true,green:scope.row.order_status=='19800',grey:'10200,19900'.search(scope.row.order_status)>-1}">
                                {{scope.row.order_status|turnValToText("order_status")}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div class="btnLine">  <el-button  size="mini" plain @click="toProgress(scope.row)">查看进度</el-button></div>
                            <!-- <div class="btnLine">  <el-button  size="mini" plain @click="toDetail(scope.row)">查看详情</el-button></div> -->
                            <!-- <el-button type="primary" @click="toEdit(scope.row)">编辑</el-button> -->
                            
                        </template>
                    </el-table-column>

                    <div class="no-content" slot="empty">
                        <i class="ic-empty"></i> 
                        <span class="text">暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="paginationWrap">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[5, 10, 20, 100]"
                  :page-size="showCount"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  background
                >
                </el-pagination>
            </div>
        </div>
        
        <el-dialog :visible.sync="dialogImgVisible">
            <img width="100%" :src="dialogImgUrl" alt="">
        </el-dialog>

    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    import api from '@/api/index.js'
    import request from '@/utils/request'
    import {ufunction} from '@/utils/tools'
    export default {
        computed: {
            ...mapGetters([
                'userId'
            ])
        },
        data() {
            return {
                uploadApi: api.uploadfilebatch,
                isLoading:false,
                
                search_type:'',
                search_status:'',
                search_sort:'',
                tableData: [],
                // 分页
                currentPage:1,
                showCount:'',
                total:0,
                order_type_word:[],
                order_status_word:[],
                order_sort_word:[],

                // 预览图片
                dialogImgUrl: '',
                dialogImgVisible: false,
                 
            }
        },
        watch: {
            '$route': {
                handler: function(route) {
                    this.showCount = Number(this.$route.query.size) ? Number(this.$route.query.size) : 10
                    this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                    this.search_type = this.$route.query.type||''
                    this.search_status = this.$route.query.status||''
                    this.search_sort = this.$route.query.sort||"1"
                    this.getTableData();
                },
                immediate: true
            }
        },
        created() {
            // this.getTableData()
            this.initWordData()
        },
        computed: {
            ...mapGetters([
                'userId', 'token', 'phone', 'userInfo'
            ]),
            api() {
                return api
            },
            IMG_PREV() {
                return api.imgPrev
            },
        },
        methods: {
            // 图片预览
            handleImgPreview(url) {
                this.dialogImgUrl = url;
                this.dialogImgVisible = true;
            },

            initWordData(){
                let wordData=ufunction.wordData
                this.order_type_word=JSON.parse(JSON.stringify(wordData.order_type))
                this.order_type_word.unshift({
                    value:'',
                    text:"全部类型"
                })
                this.order_status_word=JSON.parse(JSON.stringify(wordData.order_status))
                this.order_status_word.unshift({
                    value:'',
                    text:"全部状态"
                })
                this.order_sort_word=wordData.order_sort
            },
            toOrderAdd() {
                this.$router.push('/addCmt')
            },
            toProgress(list){
                console.log(list)
                this.$router.push({
                    path: 'orderProgress',
                    query: {
                        orderNumber: list.order_number,
                        orderType: list.order_type,
                        brandUserId: list.user_id
                    }
                })
            },
            toDetail(list) {
                console.log(list)
                this.$router.push({
                    path: 'orderDetail',
                    query: {
                        orderNumber: list.order_number,
                        orderType: list.order_type,
                        brandUserId: list.user_id
                    }
                })
            },
            toEdit(list, reorder) {
                let path = ''
                let type = list.order_type
                if (type == 'cmt') {
                    path = '/editCmt'
                }
                if (type == 'oem') {
                    path = '/editOem'
                }
                this.$router.push({
                    path: path,
                    query: {
                        orderNumber: list.order_number,
                        orderType: type,
                        fadanUserId: list.user_id,
                        reorder: reorder
                    }
                })

                console.log(list)
            },
            handleSizeChange(val) {
                this.showCount = val
                this.currentPage = 1
                this.curRoutePush()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.curRoutePush()
            },
            curRoutePush() {
                this.$router.push('/order'+
                '?page=' + this.currentPage + 
                '&size=' + this.showCount+
                '&type=' + this.search_type+
                '&status=' + this.search_status+
                '&sort=' + this.search_sort
                ).catch(err => {
                    err
                })
            },
            getTableData() {
                let _this = this
                _this.isLoading=true
                let arg = {
                    currentResult:_this.currentPage,// parseInt(_this.showCount) * (parseInt(_this.currentPage) - 1),//起始查询条数
                    orderByType: this.search_sort,
                    orderStatus: this.search_status,
                    orderType: this.search_type ,
                    showCount: this.showCount,//相当于pageSize
                    token: this.token,
                    userId: this.userId,
                }
                console.log(arg,"查询的参数")
                request({
                    url: api.requestshengchanUserOrderListByCount,//品牌商的列表接口 requestUserOrderList  requestUserOrderListBycount
                    // url: api.requestshengchanUserOrderListByCount,//生产商的列表接口
                    data: arg
                }).then(res => {
                    _this.isLoading=false
                    if(res.errorCode==200){
                        _this.tableData = res.data.orderList
                        _this.total=res.data.totalCount
                    }else{
                        _this.tableData =[]
                        _this.total=0
                    }
                    
                }).catch(err => {
                    console.log(err)
                    _this.isLoading=false
                })
            }

        }
    }
</script>

<style scoped="scoped" lang="scss">
    .pageTitle {
        padding: 24px 0;
        .arrow-right {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.65);
            margin: 0 8px;
        }
        .text1 {
            font-size: 14px;
            line-height: 22px;      
            color: rgba(0, 0, 0, 0.45);
        }
        .text2 {
            font-size: 14px;
            line-height: 22px;      
            color: rgba(0, 0, 0, 0.65);
        }
    }
    
    .order-list-page{
        .pageCenter{width: 1184px;margin:0 auto;}
        .searchWrap{text-align: right;padding:16px 24px; background: #fff;
            .el-select{margin-left:24px;width: 170px;;}
        }
        .tableWrap{
            background: #fff;
            padding:0 24px;
            .orderImgTd{
                display: flex;
                .avatarBox { 
                    width: 64px; height: 64px; display: inline-block;
                    margin-right: 16px;background: #fff; vertical-align: top;
                    flex: none;
                    .listAvatar {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .rightBox{
                    display: inline-block; 
                    .nameLine{font-size: 16px;color: rgba(0, 0, 0, 0.85);margin-bottom: 8px;font-weight: 600;
                    text-align: justify;}
                    .timeLine{font-size: 14px;color: rgba(0, 0, 0, 1);margin-bottom: 2px;}
                }
            }
            .priceText{color: #FF4D4F;font-size: 20px;}
            .btnLine{margin-bottom: 10px;}
            
        }
        .paginationWrap{padding:23px 32px;text-align: right;}
    }
    
</style>
